
<template>
  <div class="termos-container">
    <header class="termos-header">
      <h1>TERMOS E CONDIÇÕES DE USO</h1>
      <div class="empresa-info">
        <p><strong>OVER X TECNOLOGIA LTDA</strong></p>
        <p>CNPJ nº 54.703.652/0001-11</p>
        <p>Rua Graciano Neves, nº 266, LOJA 01 EDIF Brasília, Centro</p>
        <p>Vitória/ES, CEP 29015-330</p>
      </div>
      <p class="last-update"><strong>Última Alteração:</strong> 25 de junho de 2024</p>
    </header>

    <section class="introducao">
      <p>A OVER X TECNOLOGIA LTDA, doravante denominada de <strong>CONTRATADA</strong>, estabelece nestes termos e condições de uso a regulação do licenciamento e da utilização da plataforma virtual de gestão de atendimento e intermediação de serviços denominada "OVERX".</p>
      <p>O estabelecimento comercial que utilizar a plataforma será doravante denominado de <strong>Contratante</strong>.</p>
      <p>O Contratante e a Contratada serão doravante referidos, quando em conjunto, como <strong>"Partes"</strong> e, isoladamente, <strong>"Parte"</strong>.</p>
      <p>
        Inicialmente, mister se faz que a Contratante leia, entenda e concorde com os presentes Termos e Condições de Uso antes de utilizar a plataforma. 
      </p>
    </section>

    <div class="capitulos">
      <section class="capitulo">
        <h2>1. CONSIDERAÇÕES INICIAIS</h2>
        <p>Inicialmente, mister se faz que a Contratante leia, entenda e concorde com os presentes Termos e Condições de Uso antes de utilizar a plataforma, ficando vinculado aos termos e condições de uso aqui exposto.</p>
      </section>

      <section class="capitulo">
        <h2>2. OBJETO DOS TERMOS E CONDIÇÕES DE USO</h2>
        <p>2.1. Os presentes Termos e Condições de Uso regulamentam a disponibilização e o licenciamento, do Serviço de Software, em caráter não exclusivo, intransferível e temporário, do direito de utilização da Plataforma à Contratante, ficando a Contratada obrigada a prestar suporte técnico concernente à Plataforma, mediante a contratação de um dos Planos ofertados pela Contratada.</p>
        
        <h3>2.1. DA PLATAFORMA</h3>
        <p>2.1.1. A Plataforma é disponibilizada pela Contratada de modo a permitir a intermediação da compra e venda de produtos entre a Contratante (Estabelecimento Comercial) e os Clientes (aqueles que adquirem produtos ou serviços através da plataforma), com integração de aplicativos de terceiros, por meio do Atendente Virtual disponibilizado pela Contratada, bem como de outras soluções, como a disponibilização de Cardápio Digital na Plataforma e de outras funcionalidades já existentes ou que venham ser desenvolvidas, a depender do Plano contratado pela Contratante.</p>
        
        <h3>2.2. PLANOS DISPONÍVEIS</h3>
        <div class="planos-table">
          <div class="plano-item">
            <h4>2.2.1. Plano STARTER</h4>
            <p><strong>Mensalidade:</strong> R$ 129,00</p>
            <p><strong>Anualidade:</strong> R$ 1.320,00 (desconto de 15%)</p>
          </div>
          <div class="plano-item">
            <h4>2.2.2. Plano STANDARD</h4>
            <p><strong>Mensalidade:</strong> R$ 159,00</p>
            <p><strong>Anualidade:</strong> R$ 1.530,00 (desconto de 15%)</p>
            <p>Até 450 pedidos</p>
            <p><strong>Custo por pedido que exceder o limite:</strong> R$ 1,10</p>
          </div>
          <div class="plano-item">
            <h4>2.2.3. Plano PREMIUM</h4>
            <p><strong>Mensalidade:</strong> R$ 239,00</p>
            <p><strong>Anualidade:</strong> R$ 2.437,80 (desconto de 15%)</p>
            <p><strong>Pedidos Ilimitados</strong></p>
          </div>
        </div>

        <h3>2.3. FUNCIONALIDADES DA PLATAFORMA</h3>
        <div class="funcionalidades">
          <div class="coluna">
            <ul>
              <li>Chatbot Whatsapp + cardápio digital</li>
              <li>Gestão em CRM web, Mobile e App</li>
              <li>Integração automática com ifood para gestão unificada</li>
              <li>Pagamento online via pix</li>
              <li>Pesquisa de satisfação com clientes e recolhimento de feedbacks</li>
              <li>CRM web e mobile</li>
              <li>QR code de cardápio de mesas</li>
              <li>Cadastro de entregadores</li>
              <li>Cupom de desconto</li>
              <li>Relatório financeiro e de vendas</li>
            </ul>
          </div>
          <div class="coluna">
            <ul>
              <li>Importação de cardápio Ifood</li>
              <li>Roteirização automática de entregas</li>
              <li>Atualização automática de pedido</li>
              <li>Suporte diário</li>
              <li>Histórico de pedido</li>
              <li>Monitoramento em tempo real das entregas</li>
              <li>Atualização automática do status para clientes via whatsapp</li>
              <li>Gestão de atendimentos por meio do Atendente Virtual</li>
              <li>Disponibilização de programas de fidelidade para Consumidores</li>
              <li>Integração com impressoras da Contratante</li>
              <li>Disponibilização de cupons e promoções aos consumidores</li>
            </ul>
          </div>
        </div>

        <h3>2.3.1. SERVIÇOS PARA CLIENTES</h3>
        <p>Por meio da Plataforma, os Clientes terão acesso aos seguintes serviços:</p>
        <ul>
          <li>Interação com o Atendente Virtual da Contratada, integrado em aplicativos como o WhatsApp</li>
          <li>Visualização dos produtos ofertados pela Contratante em seu Cardápio Digital na Plataforma</li>
          <li>Seleção de produtos para compra na Plataforma</li>
          <li>Definição do endereço de entrega dos produtos via cadastro na Plataforma</li>
          <li>Realização de ordem de compra dos produtos à Contratante</li>
          <li>Eventuais interações com outras soluções disponibilizadas pela Contratada</li>
        </ul>

        <h3>2.4. ATUALIZAÇÕES DA PLATAFORMA</h3>
        <p>2.4. À Contratada também será reservado o direito de atualizar a Plataforma, suas soluções e demais aplicações correspondentes, a seu exclusivo critério e discricionariedade, a qualquer tempo, ficando a Contratante ciente de que a Contratada poderá, eventualmente, modificar a dinâmica de utilização e a forma de apresentação da Plataforma, incluindo o seu design e layout.</p>
        <p>2.4.1. Fica estabelecido que a alteração da Plataforma pela Contratada não ensejará à Contratante qualquer direito de resilição do Plano contratado nem de devolução de valores.</p>
      </section>

      <section class="capitulo">
        <h2>3. ADESÃO AOS TERMOS E CONDIÇÕES DE USO</h2>
        <p>3.1. Ao contratar um dos Planos (inclusive nas modalidades de teste ou de contratação gratuita) e/ou utilizar a Plataforma, a Contratante <strong>DECLARA</strong> ter lido, compreendido, e, expressamente, declara <strong>ACEITAÇÃO</strong> de todas as condições destes Termos e Condições de Uso.</p>
        <p>3.2. Ao contratar um dos Planos e/ou utilizar a Plataforma, ainda que de forma parcial ou a título de teste, o Contratante estará vinculada aos Termos e Condições de Uso, manifestando sua concordância integral com os termos e disposições deste documento.</p>
      </section>

      <section class="capitulo">
        <h2>4. PROCESSO DE ATIVAÇÃO</h2>
        <p>4.1. Para fins de ativação do sistema contratado, a Contratante se obriga a fornecer à Contratada, as informações necessárias ao Processo de Ativação, no intuito de contribuir com a celeridade, eficiência e segurança.</p>
        <p>4.2. Após a contratação do Plano, a Contratante deverá realizar o Processo de Ativação da Plataforma, de acordo com as instruções apresentadas pela Contratada e disponibilizadas na Plataforma.</p>
        <p>4.3. Após a contratação do Plano, a Contratante não poderá suspender ou interromper o prazo de vigência do Plano contratado, independentemente da periodicidade contratada.</p>
        <p>4.4. Todos os Planos atualmente vigentes, independentemente de descontinuidade de oferta pela Contratada, estarão sujeitos aos presentes Termos e Condições de Uso, a partir de sua entrada em vigor.</p>
      </section>

      <section class="capitulo">
        <h2>5. MIGRAÇÃO DE PLANO</h2>
        <p>5.1. A Contratante poderá alterar o Plano contratado para qualquer outro Plano disponibilizado pela Contratada, de qualquer periodicidade, observadas as seguintes condições:</p>
        <p>5.1.1. A migração para um Plano com benefícios e funcionalidades mais amplas implicará no pagamento da diferença entre o Plano atual e o Plano a ser aderido, observando que a contratação do novo Plano entrará em vigor, automaticamente, após a compensação do pagamento da diferença.</p>
        <p>5.1.2. Via de regra, a migração para um Plano com menores benefícios e funcionalidades deverá efetivada após o término do prazo do Plano originalmente contratado.</p>
        <p>5.2. Em caso de existência de crédito não haverá restituição de valor à Contratante pela Contratada, que somente poderá usar o crédito para o pagamento subsequente das taxas cobradas pela Contratada.</p>
      </section>

      <section class="capitulo">
        <h2>6. DO PAGAMENTO</h2>
        <p>6.1. Pela adesão de Planos com os serviços de suporte técnico da Plataforma, a Contratante pagará à Contratada o valor referente ao Plano contratado, de acordo com periodicidade contratada, e de forma antecipada.</p>
        <p>6.1.1 A Contratante assume a modalidade de pagamento 'pré-pago', isto é, deverá realizar o pagamento do Plano contratado de forma antecipada.</p>
        <p>6.3. A Contratada poderá alterar os preços dos Planos ofertados, desde que, qualquer alteração de preço seja antecipadamente comunicada à Contratante.</p>
        <p>6.3.1. A continuidade do uso da Plataforma importará em concordância por parte da Contratante com as mudanças de preço.</p>
        <p>6.5. O atraso ou inadimplemento de qualquer valor devido pelo Contratante na sua respectiva data de vencimento ensejará a cobrança de multa de 10% (dez por cento) do valor devido, acrescido de juros de mora de 1% (um por cento) ao mês.</p>
        <p>6.6. O atraso ou falta de pagamento de qualquer valor devido pela Contratante à Contratada, na sua respectiva data de vencimento, causará a imediata suspensão e bloqueio das funcionalidades e/ou de acesso do Contratante à Plataforma.</p>
      </section>

      <section class="capitulo">
        <h2>7. DA RENOVAÇÃO DO CONTRATO</h2>
        <p>7.1. A contratação do Plano será renovada automaticamente após o vencimento do plano contratado.</p>
        <p>7.2. Caso a Contratante não pretenda renovar a sua assinatura, deverá comunicar a sua intenção de cancelamento à Contratada com antecedência mínima de 7 (sete) dias úteis à data da renovação automática do Plano.</p>
      </section>

      <section class="capitulo">
        <h2>8. CANCELAMENTO</h2>
        <p>8.1. A Contratante somente poderá solicitar o cancelamento do Plano contratado, com a devolução dos valores pagos, durante os primeiros 7 (sete) dias corridos contados da data de ativação do Plano.</p>
        <p>8.2. Decorrido o prazo estabelecido, o Contratante não poderá solicitar o cancelamento do ciclo de assinatura em vigor do Plano contratado com reembolso.</p>
        <p>8.3. Sem justo motivo, a Contratada poderá cancelar o Plano da Contratante, a qualquer momento, mediante o envio de notificação prévia com antecedência mínima de 30 (trinta) dias.</p>
        <p>8.4. Com justo motivo, a Contratada poderá cancelar o Plano da Contratante, a qualquer momento e sem necessidade de aviso prévio, nada devendo à Contratante a título de reembolso.</p>
        <h3>8.5. Considerar-se "justo motivo" as seguintes hipóteses:</h3>
        <ul>
          <li>Qualquer declaração prestada pela Contratante nestes Termos e Condições de Uso que não corresponda com a verdade</li>
          <li>Qualquer manifestação difamatório, discriminatório, ofensivo, obsceno, injurioso, calunioso, violento, fraudulento</li>
          <li>O descumprimento de quaisquer das cláusulas e condições previstas nestes Termos e Condições de Uso</li>
          <li>A utilização indevida da Plataforma</li>
          <li>O inadimplemento de quaisquer valores devidos pelo Contratante à Contratada por período superior a 30 (trinta) dias corridos</li>
        </ul>
      </section>

      <section class="capitulo">
        <h2>9. SERVIÇOS OPCIONAIS</h2>
        <p>9.1. A Contratante poderá realizar a contratação de módulos de serviços opcionais já oferecidos e comercializados pela Contratada, com valores, prazos e serviços a serem estabelecidos no momento da contratação.</p>
        <p>9.1.2. Os módulos de serviços opcionais não estarão compreendidos nos Planos comercializados pela Contratada.</p>
      </section>

      <section class="capitulo">
        <h2>10. OBRIGAÇÕES E RESPONSABILIDADES DA CONTRATANTE</h2>
        <h3>10.1. Constitui obrigação da Parte Contratante:</h3>
        <ul>
          <li>Possuir capacidade jurídica, amplos poderes e todas as autorizações necessárias</li>
          <li>Possuir todas as licenças, autorizações e documentações necessárias ao seu funcionamento</li>
          <li>Responsabilidade pela negociação com consumidores na compra e venda</li>
          <li>Responsabilidade sobre os produtos cadastrados e ofertados aos Consumidores</li>
          <li>Responsabilidade pelo cadastramento dos produtos no Cardápio Digital</li>
          <li>Responsabilidade pela revisão e validação das informações de produtos cadastradas</li>
          <li>Responsabilidade pela constituição de todo o conteúdo informacional</li>
          <li>Responsabilidade pela veracidade de todas as informações cadastradas na Plataforma</li>
          <li>Responsabilidade por garantir que apenas pessoas autorizadas possam acessar a Plataforma</li>
          <li>Responsabilidade por qualquer dano ocasionado aos Consumidores ou a terceiros</li>
          <li>Responsabilidade por possuir os equipamentos com características técnicas necessárias</li>
          <li>Responsabilidade pela emissão do documento fiscal aplicável</li>
          <li>Responsabilidade pela preparação, envio e entrega dos produtos comercializados</li>
          <li>Responsabilidade pela prestação de auxílio e suporte para a conclusão dos pedidos</li>
          <li>Responsabilidade pelos custos de reembolso quando houver chargeback</li>
        </ul>
      </section>

      <section class="capitulo">
        <h2>11. REGRAS DE UTILIZAÇÃO DA PLATAFORMA</h2>
        <p>11.1. A Contratante será responsável por todos os atos praticados na Plataforma.</p>
        <p>11.2. A Contratante terá acesso à Plataforma por meio de login e senha individuais e intransferíveis.</p>
        <p>11.3. A Contratada não terá nenhuma ingerência e/ou controle sobre o teor das comunicações realizadas entre a Contratante e os Consumidores.</p>
        <p>11.3.1. Compete à Contratante conceder acesso à Plataforma somente a pessoas de sua confiança.</p>
        <p>11.3.2. A Contratante se obriga na utilização da Plataforma com intuito e fins lícitos.</p>
        <p>11.3.3. É defeso à Contratante promover atividades criminosas e/ou ilícitas em geral.</p>
      </section>

      <section class="capitulo">
        <h2>12. OBRIGAÇÕES DA CONTRATADA</h2>
        <h3>12.1. Constituem obrigações da Contratada:</h3>
        <ul>
          <li>Viabilizar o funcionamento regular da Plataforma durante todo o prazo do Plano contratado</li>
          <li>Corrigir eventuais falhas de programação e/ou alterar especificações da Plataforma</li>
          <li>Fornecer o acesso da Plataforma à Contratante durante a vigência do Plano contratado</li>
          <li>Disponibilizar serviços de suporte à Contratante no período compreendido das 10h às 23h (Horário de Brasília)</li>
          <li>Manter em sigilo todos os dados cadastrais da Contratante</li>
        </ul>
      </section>

      <section class="capitulo">
        <h2>13. INEXISTÊNCIA DE VÍNCULOS</h2>
        <p>13.1. Por força destes Termos e Condições de Uso não se estabelece nenhum tipo de sociedade, associação ou qualquer outro tipo de vínculo entre o Contratante e a Contratada.</p>
        <p>13.2. À Contratante caberá a responsabilidade em arcar com a totalidade das despesas e custos referentes encargos sociais, trabalhistas, previdenciários, impostos diretos e indiretos e demais custos administrativos relativos às suas atividades.</p>
      </section>

      <section class="capitulo">
        <h2>14. DA ENTREGA</h2>
        <p>
          14.1. Os Entregadores voluntariamente cadastrados na Plataforma e os Operadores Logísticos atuam de forma independente nas atividades de Entrega, 
          como parte da operacionalização da atividade de agenciamento e intermediação da Overx para com os Estabelecimentos Parceiros e Clientes Finais nos 
          planos nos quais o Estabelecimento Parceiro não detém logística própria, seja permanente ou temporariamente. Para constante otimização do 
          compartilhamento da plataforma, outras atividades semelhantes às de entrega podem ser agregadas adicionalmente.
        </p>
        <p>
          14.2. Os Entregadores que executarem atividades de entrega para Operadores Logísticos e utilizarem a Plataforma, declaram expressamente, 
          por meio do aceite a estes Termos, que concordam e reconhecem que a Overx firma contratos específicos de Parceria Comercial com cada um dos 
          Operadores Logísticos, sendo certo que estes Termos se aplicam aos Entregadores em questão somente naquilo em que não forem conflitantes com 
          referidos contratos e/ou com os acordos firmados entre os Operadores Logísticos e os seus respectivos Entregadores, incluindo, mas não se 
          limitando à forma de remuneração pactuada diretamente entre os Operadores Logísticos e tais Entregadores.
        </p>
        <p>
          14.2.2. A Overx poderá, a seu exclusivo critério, cobrar dos Clientes Finais um valor de taxa de intermediação 
          (que poderá ser denominada de “taxa de entrega”, “taxa de serviço” ou outra) nos casos em que atua como contratante intermediário dos 
          Estabelecimentos Parceiros que contratarem os planos que preveem a entrega.
        </p>
        <p>
          14.2.3. Os Entregadores reconhecem e concordam que os valores devidos pelas entregas serão definidos de acordo com a contratação dos 
          serviços de entrega, como entabulado na cláusula 15 e não guardam qualquer relação com as taxas eventualmente pagas pelos Clientes Finais ou 
          pelos Estabelecimentos Parceiros.
        </p>
        <p>
          14.2.4. OS ENTREGADORES RECONHECEM E DECLARAM CONCORDÂNCIA DE QUE O OVER X NÃO É UMA EMPRESA ESPECIALIZADA EM TRANSPORTE OU OPERAÇÃO 
          LOGÍSTICA, LHE CABENDO TÃO SOMENTE A DISPONIBILIZAÇÃO DE UMA PLATAFORMA TECNOLÓGICA QUE POSSIBILITA A COLABORAÇÃO ENTRE OS QUE DESEMPENHAM 
          ATIVIDADES RELACIONADAS - ASSIM, A ATIVIDADE DE ENTREGA, BEM COMO QUAISQUER PERDAS, PREJUÍZOS E/OU DANOS DECORRENTES OU RELATIVAS A TAL ATIVIDADE, 
          SÃO DE RESPONSABILIDADE EXCLUSIVA DOS ENTREGADORES.
        </p>
        <p>
          14.3. O Entregador DECLARA que possui todas as autorizações e documentações necessárias, de acordo com a legislação aplicável, 
          inclusive a legislação de trânsito, para atuar nas atividades de entrega e que tem ciência e assume todos os riscos envolvidos na execução 
          das suas atividades, possuindo pleno conhecimento de todos os cuidados necessários e razoavelmente esperados para que a atividade seja desenvolvida 
          com a máxima qualidade e segurança.
        </p>
        <p>
          14.4. O Entregador reconhece e concorda que o Overx:
        </p>
        <ul>
          <li>
            <p>14.4.1. não realiza processo seletivo;</p>
            <p>14.4.2. não promove treinamentos referente à execução das atividades de entrega;</p>
            <p>
              14.4.3. não exige disponibilidade e, tampouco, periodicidade do Entregador para a execução das atividades de entrega, sendo que o 
              Entregador tem autonomia e independência para realizar entregas se e quando desejar;
            </p>
            <p>
              14.4.4. não fiscaliza as suas atividades, seja pela própria Plataforma ou por qualquer outro meio.
            </p>
          </li>
        </ul>
      </section>

      <section class="capitulo">
        <h2>DOS VALORES PAGOS PARA A ENTREGA</h2>
        <p>
          15.1. Os valores a serem pagos pelas Entregas serão calculados automaticamente por meio de algoritmo e serão disponibilizados ao 
          Entregador juntamente com a oferta de Entrega na Plataforma, para que o Entregador possa, a seu único e exclusivo critério, aceitar, 
          recusar ou ignorar a referida oferta.
        </p>
        <p>
          15.1.1.Para cálculo do valor pago pela entrega, o algoritmo poderá levar em conta, sem limitação: 
        </p>
        <ul>
          <li>a) ponto(s) de coleta(s); </li>
          <li>b) ponto(s) de entrega(s);</li>
          <li>c) distância percorrida; </li>
          <li>d) tempo para deslocamento;</li>
          <li>e) condições de trânsito </li>
          <li>f) oferta e demanda.</li>
        </ul>

        <p>
          15.2. Nos casos onde ocorram acréscimos de ponto(s) de coleta, ponto(s) de entrega, distância percorrida, tempo para deslocamento 
          (ou tempo de espera) ou condições de trânsito que sejam posteriores à oferta da Entrega, a Over X informará ao Entregador para que este 
          novamente possa optar por aceitar ou recusar, sendo que, caso o Entregador aceite, a Over X poderá gerar um crédito adicional nos valores que 
          o Entregador receberá, de acordo com os acréscimos realizados em relação à oferta inicial.
        </p>
        <p>
          15.3. O Entregador, AUTORIZA, expressamente, a Over X a realizar a retenção de quaisquer valores a ele devidos nas hipóteses em 
          que essa tenha uma suspeita plausível e provas mínimas de dano e/ou prejuízo sofridos pela própria OVER X, pelos Clientes Finais, 
          pelos Estabelecimentos Parceiros e/ou terceiros em decorrência de ação ou omissão do Entregador durante a execução da Atividade de Entrega.
        </p>
        <p>
          15.4. Em caso de alteração dos dados bancários, o Entregador compromete-se a solicitar a atualização dos dados bancários 
          imediatamente, sob pena de os depósitos realizados em conta bancária anteriormente informada serem considerados válidos.
        </p>
        <p>
          16. A Over X poderá, a seu exclusivo critério, disponibilizar na Plataforma a possibilidade de o Cliente Final pagar uma gorjeta ao Entregador; 
          nestas hipóteses, a gorjeta será paga diretamente pelo Cliente Final e repassada integralmente ao Entregador em conjunto com os valores devidos 
          pelo Over X em contrapartida das Entregas por ele aceitas e concluídas.
        </p>
        <p>
          16.1. O pagamento de gorjeta é opcional e ficará a exclusivo critério do Cliente Final, e o OverX não exerce qualquer ingerência em 
          relação a tais valores.
        </p>
        <p>
          16.2. Os valores de gorjeta eventualmente pagos pelos Clientes Finais aos Entregadores ficarão disponíveis para 
          consulta na Plataforma do Entregador em conjunto com os demais valores devidos como contrapartida das Entregas por eles realizadas.
        </p>
        <p>
          16.3. Os valores devidos pela OverX aos Entregadores em contrapartida pelas Entregas aceitas e concluídas serão transferidos para 
          as contas bancárias de titularidade dos Entregadores cadastradas em seus respectivos Perfis, de acordo com a periodicidade informada 
          pela Over X na Plataforma.
        </p>
        <p>
          16.3.1. A OverX poderá, a seu exclusivo critério, alterar a forma de pagamento e a periodicidade das entregas realizadas 
          pelos Entregadores, a qualquer tempo e por qualquer motivo, mediante comunicação prévia aos Entregadores com antecedência 
          mínima de 30 (trinta) dias corridos da data em que a nova forma de pagamento ou a nova periodicidade entrar em vigor, 
          por meio da Plataforma ou de quaisquer outros canais oficiais da OverX
        </p>
        <p>
          16.3.2. Para os Entregadores vinculados aos Operadores Logísticos, as Entregas e as gorjetas pagas pelos Clientes 
          Finais são pagas pelo OverX diretamente aos Operadores Logísticos e estes remuneram os seus Entregadores nos critérios 
          acordados entre os Operadores Logísticos e seus Entregadores, não tendo a OverX qualquer ingerência na forma, periodicidade e 
          valores pagos pelos Operadores Logísticos.
        </p>
        <p>
          16.4. O Entregador reconhece e atesta, ainda, que é o único responsável por quaisquer tributos, tarifas, taxas, 
          ônus ou obrigações que incidam sobre os valores recebidos pelas Entregas, sem prejuízo de eventuais retenções a 
          serem feitas pela OverX, nos termos da legislação aplicável.

        </p>
        <p>
          16.5. A OverX não se responsabilizará pelo atraso, falta e/ou eventuais diferenças nos valores depositados decorrentes de:
        </p>
        <ul>
          <li>a) ação ou omissão do Entregador;</li>
          <li>b) caso fortuito ou força maior, nos termos da legislação aplicável;</li>
          <li>c) falha da instituição financeira em que a conta do Entregador é mantida;</li>
          <li>d) cobrança indevida de taxas por instituição financeira ou sua majoração sem prévio aviso pela instituição financeira.</li>
        </ul>
      
      <p>
        16.6. Se por qualquer motivo, a OverX venha a pagar taxas, tarifas, multas ou quaisquer outros valores que deveriam ser 
        pagos pelo Entregador, a OverX fica autorizada a reter tais valores dos depósitos a serem realizados até que a OverX seja 
        devidamente ressarcida pelo Entregador .

      </p>

      <p>
        16.7. O Entregador deverá, obrigatoriamente, recusar os pedidos de entrega quando verificar qualquer irregularidade em relação ao 
        Estabelecimento Parceiro, ao Cliente Final ou ao produto a ser entregue.

      </p>
        18.1. Em caso de verificação de irregularidade de pedido, o Entregador deverá, por meio da Plataforma, comunicar imediatamente a 
        OverX para que esta possa cancelar o pedido de entrega.
      <p>
        19.2. O Entregador, por meio de sua aceitação após o cadastramento na plataforma, reconhece que ficará, a seu exclusivo critério:
      </p>

      <ul>
        <li>a) a escolha do momento em que se conectará à Plataforma;</li>
        <li>b) o tempo em que ficará ativo (“online” ou “disponível”) na Plataforma;</li>
        <li>c) a opção de aceitar ou recusar os pedidos de entrega;</li>
        <li>
          d) o período, local e quantidade de acessos à Plataforma. O Entregador reconhece que não existe qualquer participação e/ou ingerência da OverX 
          nas suas escolhas de utilização da Plataforma, podendo o Entregador acessar e usufruir da Plataforma como melhor lhe couber, desde que respeitados os 
          Termos aqui descritos.
        </li>
      </ul>

      <p>
        20. Sem prejuízo de outras obrigações estipuladas nestes Termos, o Entregador obriga-se a:
      </p>
      <p>
        20.1. desenvolver seus melhores esforços na execução das entregas, atualizando o seu status por meio da Plataforma para acompanhamento da 
        referida atividade em tempo real pelos Clientes Finais;
      </p>

      <p>
        20.2. Responder por qualquer dano causado aos produtos dos Estabelecimentos Parceiros que forem por ele entregues aos Clientes Finais, 
        exonerando a OverX de toda e qualquer responsabilidade neste sentido e se comprometendo a ressarcir o Cliente Final, o Estabelecimento 
        Parceiro e/ou a Over X de todos os danos e/ou prejuízos que este(s) venham a sofrer em decorrência de ação e/ou omissão do Entregador;
      </p>

      <p>
        20.3. Após aceitar voluntariamente a atividade por meio da Plataforma, não repassar a Entrega recebida a quaisquer terceiros, devendo 
        comunicar a OverX visando a redistribuição da atividade ou contato com o Cliente Final;
      </p>

      <p>
        20.4. responder pelo uso incorreto e/ou indevido da Plataforma;
      </p>

      <p>
        20.5. não copiar, reproduzir, distribuir, duplicar, compilar, criar obra derivada, alterar, combinar, modificar, adaptar, 
        traduzir, ampliar, mesclar, decodificar, recriar ou realizar a engenharia reversa de qualquer componente da Plataforma;
      </p>

      <p>
        20.6. indenizar a OverX (incluindo empresas coligadas, controladoras, controladas, diretores, administradores, colaboradores, representantes e 
        empregados) por quaisquer danos, prejuízos, responsabilização, reclamações, processos, perdas, demandas ou despesas, incluindo, mas não se 
        limitando a isso, honorários advocatícios, custas judiciais e ônus de sucumbência decorrentes da utilização indevida da Plataforma;

      </p>

      <p>
        20.7. dispor dos ativos, equipamentos técnicos e operacionais necessários para a realização das Atividades de Entrega, de acordo com a 
        legislação aplicável, tais como, mas não se limitando a isso, veículo, jaqueta, luva, capacete, mochila e/ou baú, arcando com todas as despesas, 
        custos, taxas, tributos e contribuições referentes a estes equipamentos;
      </p>

      <p>
        20.8. cumprir todas as leis, regulamentos e normas em âmbito federal, estadual e municipal na execução das Atividades de Entrega;
      </p>

      <p>
        20.9. assumir a responsabilidade por todas as multas, penalidades e processos administrativos ou judiciais decorrentes ou referentes às entregas 
        realizadas;
      </p>

      <p>
        20.10. em nenhuma hipótese, solicitar ou aceitar pedidos de entrega que envolvam o transporte de cartas, cartões-postais e 
        correspondências agrupadas (nos termos da Lei nº 6.538/78); de produtos ilícitos; pessoas e animais; armas de fogo ou munições; materiais 
        inflamáveis, tóxicos e/ou radioativos; drogas e entorpecentes; explosivos; joias de alto valor; elevadas quantias em dinheiro; e de quaisquer outros materiais cujo transporte seja proibido por lei.  
      </p>
      </section>

      <section class="capitulo">
        <h2>21. VIGÊNCIA</h2>

        <p>
          21.1. Os presentes Termos e Condições de Uso entrarão em vigor na data de sua adesão pelo Contratante e vigerão pelo prazo do Plano 
          contratado, renovando-se automaticamente por iguais períodos aos de renovação do Plano, conforme a periodicidade aplicável, caso o 
          Contratante não se manifeste em sentido contrário à renovação.
        </p>
      </section>

      <section class="capitulo"> 
        <h2>22. PROPRIEDADE INTELECTUAL</h2>

        <p>
          22.1. São de PROPRIEDADE EXCLUSIVA da Contratada a Plataforma disponibilizada, bem como, todos os seus componentes e 
          elementos de propriedade intelectual a ela relacionadas, incluindo novas versões e atualizações.
        </p>

        <p>
          22.1.1.Todo o conteúdo disponível na Plataforma para acesso da Contratante, assim como seus textos, desenhos gráficos, algoritmos, scripts, 
          APIs, códigos fonte, dentre outros elementos, na maior extensão permitida pela legislação aplicável, são protegidos por direito autoral 
          (Leis nº 9.609/98 – Lei proteção de Propriedade Intelectual de Programa de Computador e 9.610/98 – Lei de Proteção Autoral) e são de 
          propriedade exclusiva da Contratada.

        </p>

        <p>
          22.2. Os presentes Termos e condições de Uso, bem como a utilização da Plataforma NÃO concedem, à Contratante a aquisição de qualquer 
          direito de propriedade intelectual ou outros direitos exclusivos, incluindo patentes, desenhos, marcas, direitos autorais ou quaisquer 
          direitos sobre informações confidenciais ou segredos de negócio, em relação ao conteúdo disponibilizado na Plataforma, incluindo, mas não se 
          limitando a textos, gráficos, imagens, logotipos, ícones, fotografias, conteúdo editorial, notificações, softwares, códigos ou qualquer outro 
          material, sobre ou relacionados à Plataforma ou a algum componente dela.

        </p>

        <p>
          22.2.1. À Contratante será outorgada, durante o prazo de vigência do Plano adquirido, uma licença gratuita, não exclusiva, temporária e 
          intransferível da marca de propriedade da Contratada, denominada “OVERX”, apenas para os fins de veiculação e divulgação da marca da 
          Contratada no Cardápio Digital da Contratante, sendo certo que ao término da vigência do Plano contratado, a licença em questão se 
          extinguirá de forma automática e de pleno direito.

        </p>

        <p>
          22.3. À Contratante é defeso:
        </p>

        <ul>
          <li>
            a) Copiar, ceder, sublicenciar, vender, dar em locação ou em garantia, reproduzir, doar, alienar de qualquer forma, transferir total ou 
            parcialmente, sob quaisquer modalidades, provisória ou permanentemente, a Plataforma, assim como seus módulos, partes, manuais e 
            quaisquer informações e propriedades intelectuais que se referem à Plataforma;
          </li>
          
          <li>
            b) Alterar ou Retirar os avisos de reserva de direito contidos na Plataforma e na sua documentação, ainda que parcialmente;
          </li>

          <li>
            c) Praticar engenharia reversa, descompilação ou desmontagem da Plataforma ou de propriedades intelectuais a ela relacionadas;
          </li>

          <li>
            d) Copiar, distribuir, transmitir, publicar, ou de qualquer outra forma modificar e transferir os conteúdos da Plataforma.
          </li>
        </ul>

        <p>
          22.4. Qualquer violação ao disposto neste Capítulo constituirá infração aos direitos de propriedade intelectual da Contratada e 
          sujeitará a Contratante às sanções administrativas, civis e criminais aplicáveis.
        </p>

        <p>
          22.5. A Contratante, com a validação e contratação do Plano, expressamente autoriza e outorga a licença gratuita de uso e 
          divulgação de sua marca à Contratada, durante todo o período de vigência da relação comercial existente com a Contratada.
        </p>

        <p>
          22.5.1. Objetivando o cumprimento do presente Termo e para quaisquer fins publicitários ou de marketing  pretendidos pela Contratada, 
          fica autorizada a veiculação e divulgação da marca da Contratante no rol de clientes atendidos pela Contratada.
        </p>

        <p>
          22.6. A Contratada reserva para si todos os direitos relacionados à Plataforma e à qualquer funcionalidade oferecida nos 
          termos destes Termos e Condições de Uso, ainda que aqui não expressamente mencionados.
        </p>
      </section>

      <section class="capitulo">
        <h3>23. PROTEÇÃO E PRIVACIDADE DE DADOS</h3>

        <p>
          23.1. Em consonância com a Lei nº 12.965/2014, Lei Geral de Proteção de Dados (LGPD lei nº 13.709/2018 ) fica a Contratada obrigada a 
          realizar tratamentos de dados pessoais da Contratante, dos Consumidores e de eventuais terceiros, sobre segurança da informação, privacidade e 
          proteção de dados, observando também as demais normas setoriais ou gerais sobre o tema, inclusive internacionais quando aplicáveis, 
          comprometendo-se a tratar os dados em conformidade com tais diplomas legais e com a Política de Privacidade da Contratada.

        </p>

        <p>
          23.1.1. Por meio da adesão aos Termos e Condições de Uso e/ou pela utilização da Plataforma a Contratante declara ter ciência e manifesta 
          estar de acordo com o conteúdo da Política de Privacidade apresentada pela Contratada, sem nada opor.

        </p>

        <p>
          23.2. As Partes reconhecem que, no âmbito do objeto destes Termos e Condições de Uso, a Contratante atuará na qualidade de 
          Controlador de Dados, enquanto que a Contratada poderá atuar tanto na qualidade de Controladora de Dados, como na de Operadora de Dados, 
          conforme definidos na Lei Geral de Proteção de Dados, a depender dos tratamentos de dados realizados com relação ao Contratante e com os 
          Consumidores, conforme o caso.

        </p>

        <p>
          23.2.1. Na função de <strong>Operadora de Dados</strong>, a Contratada realizará o tratamento dos dados pessoais em conformidade com as instruções 
          e finalidades documentadas e recebidas da Contratante ou, na medida do necessário, para o adequado funcionamento da Plataforma e das soluções por 
          ela disponibilizadas. Entretanto, as decisões acerca do tratamento de dados realizada pela Contratada e das informações e soluções contidas na 
          Plataforma, serão tomadas/realizadas exclusivamente pela Contratante.
        </p>

        <p>
          23.2.2. Atuando na função <strong>Controladora de Dados</strong>, a contratada realizará o tratamento dos dados da Contratante ou de 
          Consumidores que utilizarem a Plataforma obedecendo o quanto previsto pela Política de Privacidade da Contratada.

        </p>

        <p>
          23.3. As partes, Contratante e/ou a Contratada, conforme aplicável, na qualidade de Controladora de Dados, deverá(ão) garantir:
        </p>

        <ul>
          <li>
            a) A qualidade dos dados pessoais, evitando a utilização de dados porventura incompletos, inexatos ou desatualizados;
          </li>
          <li>
            b) A legitimidade do tratamento de dados, mediante a obtenção de consentimento do titular ou a comprovação de outra base legal aplicável
            para a realização do tratamento, bem como, a descrição das finalidades do tratamento que deverão ser compatíveis com a base legal aplicável, 
            em consonância com a Lei Geral de Proteção de Dados.
          </li>
        </ul>
      

      <p>
        23.4. As Partes se obrigam a empregarem os seus melhores esforços, tomarem todas as medidas de segurança técnica e organizacional a fim de evitar:
      </p>

      <ul>
        <li>	
          a) O tratamento não autorizado ou ilegal de dados;
        </li>

        <li>
          b) Perda ou destruição acidental de dados durante o tratamento e consequentes danos. Ainda, conforme exigido por lei, as Partes adotarão 
          mecanismos de autenticação de acesso aos registros cabíveis e, quando necessário, o uso de soluções de gestão de registros por meio de 
          técnicas que razoavelmente impeçam a violabilidade de dados, como encriptação, anonimização ou outras medidas de proteção equivalentes, 
          conforme o caso.
        </li>
      </ul>
      <p>
        23.5. Por este ato, fica a Contratada responsável por eventual acesso indevido, não autorizado e pelo vazamento ou 
        perda de dados da Contratante que lhe sejam confiados em decorrência da sua qualidade de Operadora de Dados.
      </p>

      <p>
        23.5.1. A Contratada ficará responsável pelos prejuízos decorrentes de incidentes que não decorram de culpa do Contratante, 
        no limite de sua responsabilidade

      </p>

      <p>
        23.6 A responsabilidade da Contratada fica excluída nos casos em que o acesso à Plataforma e ou ao sistema decorra por culpa exclusiva do 
        Contratante nas hipóteses em que haja acesso à plataforma por terceiro com dados de login do Contratante, ou de terceiros.
      </p>

      <p>
        23.7. Excluída a responsabilidade da Contratada por culpa exclusiva da Contratante ou terceiro, a Contratante deverá reembolsar a 
        Contratada integralmente pelos custos arcados pela Contratada para resposta ou minimização do incidente, sem prejuízo das demais 
        perdas e danos cabíveis.

      </p>

      <p>
        23.8. Com o término do prazo destes Termos e Condições de Uso, a Contratada se desobriga em manter quaisquer dados do Contratante ou 
        dados relacionados ou decorrentes à prestação de serviços ao Contratante, podendo excluir todos e quaisquer dados da Contratante, 
        tratados à prestação dos serviços, nos termos do seu programa de gestão de armazenamento de dados. 

      </p>

      <p>
        23.8.1. Fica facultado à Contratada a manutenção dos dados pessoais nas hipóteses elencadas no art. 16 da Lei Geral de Proteção de Dados.

      </p>

      <p>
        23.9. A Contratada poderá manter e compilar, de forma anônima, informações estatísticas relacionadas à performance da Plataforma e 
        aos serviços por ela disponibilizados, com a finalidade do aprimoramento da Plataforma, desde que tais informações não impliquem na 
        identificação dos dados da Contratante ou por ele fornecidos, nada obstante o consentimento fornecido pelo Contratante para o tratamento 
        de seus dados por estes Termos e Condições de Uso.
 
      </p>
      </section>
      <section class="capitulo">
        <h2>LIMITAÇÃO DE RESPONSABILIDADE: SERVIÇOS E APLICATIVOS DE TERCEIROS</h2>

        <p>
          24.1. A Contratante reconhece que a Plataforma adquirida pela OVERX poderá ser integrada a Aplicativos de Terceiros e, 
          por esta razão, DECLARA ciência de que a Contratada não possui ingerência ou controle sobre os Aplicativos de Terceiros, 
          sendo certo que não poderá ser responsabilizada:
        </p>
        <ul>
          <li>
            a) Por eventuais descumprimentos dos termos de uso, política de privacidade e/ou quaisquer regulamentos de utilização dos Aplicativos de 
            Terceiros;
          </li>
          <li>
            b) Por eventuais indisponibilidades ou mau funcionamento, transitório ou permanente, dos Aplicativos de Terceiros; 
          </li>
          <li>
            c) Por eventual bloqueio da conta/número telefônico no contexto da execução dos referidos serviços dos Aplicativos de Terceiros ou qualquer 
            outra consequência que tenha como causa serviços dos Aplicativos de Terceiros, em decorrência das normas provenientes de seus termos e 
            condições de uso e/ou quaisquer regulamentos de utilização.
          </li>
        </ul>

        <p>
          24.2. A Contratante DECLARA ciência do conteúdo das regras que regem a utilização dos Aplicativos de Terceiros integrados à Plataforma, 
          reconhecendo neste ato que somente optará por usufruir deles se concordar plenamente com tais regras, comprometendo-se a permanecer adequadas a elas.
        </p>

        <p>
          24.2.1. A Contratante reconhece e <strong>expressamente</strong> DECLARA que os presentes Termos e Condições de Uso, a 
          Política de Privacidade, bem como, os demais documentos relacionados à utilização da Plataforma OVERX não serão aplicáveis com relação 
          à utilização dos serviços e das funcionalidades de Aplicativos de Terceiros, ainda que integrados à Plataforma OVERX.
        </p>

        <p>
          24.2.2. Em caso de uso de Aplicativos de Terceiros pela Contratante, esta estará sujeita ao quanto regido pelos próprios termos de uso 
          e políticas de privacidade estabelecidos pela empresa provedora dos Aplicativos de Terceiros.
        </p>

        <p>
          24.3. A Contratante, DECLARA ciência e concordância de que a OVERX não se responsabilizará pelo bom funcionamento quando 
          contratada apenas para a venda e intermediação. Sua responsabilidade se limitará às atividades de venda ou intermediação através da Plataforma.
        </p>

        <p>
          24.4. A Contratada <strong>não</strong> se responsabiliza, nem mesmo possui ingerência em conceder abatimentos ou suspensão de exigibilidade, 
          integral ou parcialmente, dos pagamentos a si devidos conforme o Plano contratado, por conta da inviabilização do uso de alguma(s) de 
          suas funcionalidades em razão de impedimento de empresas terceiras. Assim, não assumirá o ônus nas hipóteses:
        </p>

        <ul>
          <li>	a) cancelamento ou suspensão da conta da Contratante em Aplicativos de Terceiros;</li>
          <li>
            b) indisponibilidade técnica (momentânea ou permanente) dos Aplicativos de Terceiros;
          </li>
          <li>
            c) fechamento da empresa terceira detentora do aplicativo ou descontinuidade de sua atividade empresarial
          </li>
        </ul>

        <p>
          24.5. A Contratada reconhece e declara que será de sua exclusiva responsabilidade  a análise dos pedidos realizados pelos Consumidores, 
          bem como a verificação a respeito do pedido ser completo ou suspeito. Assim, nem o Sistema de Pagamentos nem a Contratada podem reconhecer 
          se um pedido realizado na Plataforma está correto ou completo, ou, ainda, se a quantidade de pedidos ou de itens de um pedido é usual para a 
          Contratada.

        </p>

        <p>
          24.6. Quando a Contratante receber qualquer pagamento diretamente do consumidor, ficará perante este, única e exclusivamente 
          responsável pelos produtos vendidos com relação a qualidade, integridade, preparo, entrega, suporte (inclusive com relação ao pagamento), 
          cobrança, reembolso, restituição, estorno, chargeback.

        </p>

        <p>
          24.6.1. A Contratante ficará obriga a indenizar a Contratada por todas e quaisquer perdas efetivamente materializadas em decorrências 
          das obrigações assumidas nesta Cláusula 15.6.

        </p>

        <p>
          24.6.2. Em casos similar ou semelhante ao do 15.6, a Contratada ficará isenta da responsabilidade integral por quaisquer reclamações em 
          razão de erros nas entregas, má qualidade de produtos, incompatibilidades entre o produto adquirido pelo Consumidor na Plataforma, bem como 
          o que for entregue pela Contratante.

        </p>

        <p>
          24.7. Quando do pagamento à Contratante ocorrer na modalidade online, pelo Sistema de Pagamentos, essa será única e exclusivamente 
          responsável perante o Consumidor e/ou terceiros pelos produtos vendidos, a qual também se obrigada na garantir qualidade, integridade, 
          preparo, entrega, suporte e por qualquer outro serviço acessório.
        </p>

        <p>
          24.7.1. Na forma do Cláusula 15.7, a Contratada ficará integralmente isenta de quaisquer reclamações, incluindo, em razão de erros nas 
          entregas, má qualidade dos produtos, incompatibilidades entre o produto adquirido pelo Consumidor na Plataforma e aquele entregue pelo 
          Estabelecimento e por quaisquer outras hipóteses relacionadas.
        </p>

        <p>
          24.7.2. Nas hipóteses em que verse questões sobre a cláusula 15.7, a Contratada desempenhará esforços para dar suporte à 
          Contratante em relação aos serviços de pagamento online, caso ocorra alguma falha de processamento do pagamento, auxiliando a 
          comunicação entre Contratante e o Sistema de Pagamentos.
        </p>

        <p>
          25. A responsabilidade perante o Consumidor por qualquer cobrança, reembolso, restituição, estorno e/ou chargeback,  
          qualquer hipótese, será da Contrante, ficando a Contratada totalmente isenta de qualquer obrigação e/ou responsabilidade nesse sentido.
        </p>

        <p>
          25.1. A contratante se obriga a indenizar e a manter a Contratada reembolsada de todas e quaisquer perdas efetivamente materializadas em 
          decorrências das obrigações assumidas nesta Cláusula 15.7.
        </p>
      </section>

      <section class="capitulo">
        <h2>26. LIMITAÇÃO DE RESPONSABILIDADE: USO DA PLATAFORMA</h2>
        <p>
          26.1. Caberá à Contratante providenciar e custear os acessos à internet e aos Aplicativos de Terceiros necessários ao uso da Plataforma ou 
          de alguma de suas funcionalidades, bem como custear as despesas referentes a tais acessos.
        </p>

        <p>
          26.1.1. A Contratada não se responsabilizará pelas falhas na conexão da Contratante, nem por aquelas na conexão da Contratante para 
          com os Aplicativos de Terceiros que utiliza.
        </p>

        <p>
          26.2. A Contratada não responderá pelos prejuízos sofridos pelo Contratante em razão de falhas de seus equipamentos ou de operação 
          de suas redes, nem por eventuais bloqueios de acesso, ou obstáculos às operações, decorrentes da desatualização das configurações de 
          acesso e permissões de utilização do usuário do Contratante na Plataforma
        </p>

        <p>
          26.2.1 A Contratante se obriga na responsabilidade de atualizar os seus dados sempre que preciso, a fim de evitar prejuízos e 
          falhas no sistema, em razão de desatualização de configuração sistema.
        </p>

        <p>
          26.3. A Contratada adotará as medidas de segurança de acordo com os padrões de mercado para a proteção das informações da Contratante, 
          armazenadas na Plataforma.
        </p>

        <p>
          26.3.1. A Contratante DECLARA e reconhece que nenhum sistema, servidor ou software está absolutamente imune a ataques e/ou invasões de 
          hackers e ou agentes maliciosos, não sendo a Contratada responsável por qualquer exclusão, obtenção, utilização e/ou divulgação não 
          autorizada de informações da Contratante, resultantes de ataques a que a Contratada não poderia razoavelmente evitar por meio dos 
          referidos padrões de segurança adotados.

        </p>

        <p>
          26.4. A Contratada não se responsabilizará por prejuízos decorrentes da violação das medidas de segurança adotadas por terceiros que 
          utilizem as redes públicas ou a internet, subvertendo os sistemas de segurança para acessar as informações do Contratante.

        </p>

        <p>
          26.5. Na extensão máxima permitida pela lei em vigor, a Plataforma é disponibilizada  à Contratante no “estado em que se encontra” e 
          “conforme a disponibilidade”, com todas as falhas e sem garantia de qualquer espécie.
        </p>
        <p>
          26.5.1. A Contratada não garante que as funções da Plataforma atendam às necessidades da Contratante ou que a Plataforma será 
          compatível ou funcionará com qualquer sistema, software, plataforma, aplicativos e/ou serviços de terceiros.
        </p>
        <p>
          26.5.2. A Contratada jamais será obrigada a customizar a Plataforma especificamente para as necessidades da Contratante e/ou 
          integrá-la com sistemas, softwares, plataformas, aplicativos e/ou serviços de terceiros já utilizados pelo Contratante. 
          Qualquer integração nesse sentido deverá ser realizada e operacionalizada exclusivamente pelo Contratante, por meio da API da 
          Plataforma, conforme disponibilizada pela Contratada.
        </p>

        <p>
          26.5.3. A Plataforma poderá estar sujeita a interferências, mau funcionamento e/ou atrasos inerentes ao uso da internet e de 
          comunicações eletrônicas.
        </p>

        <p>
          26.5.4. A Contratante declara que tem conhecimento desses riscos, ressalvados na cláusula 26.5, e que esses fatores poderão 
          afetar de algum modo a fruição da Plataforma, sem que lhe seja devida qualquer indenização por eventuais prejuízos, de qualquer 
          natureza, que venha a sofrer, a exemplo de, mas não se limitando a: danos materiais, lucros cessantes, perda de uma chance, danos morais, 
          dentre outros.
        </p>
        <p>
          26.5.5. Nas hipóteses, previstas na Cláusula 26.5, a Contratada se compromete a providenciar, com maior 
          brevidade possível, o retorno do regular funcionamento da Plataforma.
        </p>
      </section>

      <section class="capitulo">
        <h3>27. LIMITAÇÃO DE RESPONSABILIDADE: PARCEIROS E AFILIADOS</h3>
        
        <p>
          27.1. A Contratante declara conhecer, por meio da adesão aos presentes Termos e Condições de Uso, que a 
          Contratada possui programas com Parceiros e Afiliados para os seguintes fins:
        </p>

        <ul>
          <li>
            a) Divulgação, anúncio e publicidade sobre a Plataforma e sobre os Planos mantidos pela OverX;
          </li>
          <li>
            b) Prospecção, oferta, negociação e contratação de Planos da OverX;
          </li>
          <li>
            c) Atendimento especializado para implantação da Plataforma da OverX;
          </li>
          <li>
            d) Atendimento especializado para prestação de suporte referente à utilização da Plataforma da OverX.
          </li>
        </ul>

      <p>
        27.2. No âmbito de programas com Parceiros e Afiliados, estes se a obrigam a informar  à Contratante, de forma transparente e clara, 
        sobre todas as suas responsabilidades, atribuições e competências, enquanto participantes dos programas, exonerando a Contratada de 
        quaisquer responsabilidades por atos que sejam de sua atribuição e/ou competência.
      </p>
      <p>
        27.3. Sem prejuízo das obrigações de transparência e clareza com relação às responsabilidades dos Parceiros e Afiliados no âmbito 
        dos programas, a Contratante reconhece e declara, por meio da adesão aos presentes Termos e Condições de Uso, que nada terá a 
        reclamar da Contratada com relação a valores pagos aos Parceiros e Afiliados ou atos praticados pelos Parceiros e Afiliados.
      </p>
      <p>
        27.3.1. Os Parceiros e Afiliados da OverX serão os únicos e exclusivos responsáveis por todas as práticas, atos, omissões, 
        manifestações ou declarações que provoquem quaisquer danos ou prejuízos à Contratante e/ou a terceiros, e que estejam 
        relacionados às atividades do Afiliado ou do Parceiro junto à Plataforma.
      </p>
      <p>
        27.3.2. São de responsabilidade dos parceiros e Afiliados nos termos da Cláusula 26.3:
      </p>
      <ul>
        <li>
          a) Propagandas, divulgações ou ofertas em desacordo com estes Termos e Condições de Uso e/ou com a lei aplicável;
        </li>
        <li>
          b) Falhas na prestação de serviços de implantação ou de suporte que eventualmente sejam oferecidos;
        </li>
        <li>
          c) Condições ofertadas em desacordo com as políticas praticadas pela Contratada ou informações prestadas de maneira equivocada, dolosa ou culposamente;
        </li>
        <li>
          d) Violações de dados e de privacidade de terceiros.
        </li>
      </ul>
      </section>

      <section class="capitulo">
        <h2>28. INDENIZAÇÕES</h2>

        <p>
          28.1. A Contratante assume a responsabilidade civil, trabalhistas, previdenciários, acidentários, tributários, ou de 
          qualquer outra natureza, relacionados ao desenvolvimento de suas atividades e que de alguma forma venham a envolver a 
          Contratada (ou seus sócios, suas afiliadas, controladas ou pessoas pertencentes ao seu grupo econômico).
        </p>
        <p>
          28.1.1 A Contratante isentará a Contratada de quaisquer perdas. Nas hipóteses de não exclusão de responsabilidade da Contratada, a 
          Contratante se compromete:
        </p>
        <p>
          28.1.1.1. Fornecer à Contratada cópias integrais das respectivas demanda, permitindo que a Contratada intervenha e 
          coopere para a sua improcedência;
        </p>
        <p>
          28.1.1.2. Reembolsar à Contratada, no prazo de 72 (setenta e duas horas), todas as despesas que esta venha a realizar em 
          decorrência de tais demandas e pleitos.
        </p>

        <p>
          28.2. Nada obstante o disposto na Cláusula 19.1 acima, a Contratante, ainda, em caráter irrevogável e irretratável, 
          obriga-se a indenizar e manter indene a Contratada por todas e quaisquer perdas efetivamente materializadas pela Contratada, 
          decorrentes ou relacionadas:
        </p>
        <p>
          28.2.1. Descumprimento destes Termos e Condições de Uso pelo Contratante;
        </p>
        <p>
          28.2.2. Omissão, falsidade ou incompletude das declarações e garantias prestadas nestes Termos e Condições de Uso pelo Contratante;
        </p>
        <p>
          28.2.3. Responsabilização da Contratada por alguma obrigação do Contratante em face de terceiros.
        </p>
        <p>
          28.3. Observadas as limitações de responsabilidade previstas nos Capítulos 15 e 17, as demais limitações de 
          responsabilidade previstas nestes Termos e Condições de Uso, bem como as declarações de assunção de responsabilidade da 
          Contratante, prestadas por estes Termos e Condições de Uso, a Contratada, em caráter irrevogável e irretratável, obriga-se a 
          indenizar e manter a Contratante indenizada por todas e quaisquer perdas efetivamente materializadas pela Contratante, decorrentes ou relacionadas:
        </p>

        <p>
          28.3.1. Descumprimento destes Termos e Condições de Uso pela Contratada;
        </p>
        <p>
          28.3.2 Omissão, falsidade ou incompletude das declarações e garantias prestadas pela Contratada;
        </p>
        <p>
          28.3.3. Responsabilização do Contratante por uma obrigação da Contratada em face de terceiros.
        </p>
        <p>
          28.4. AS PARTES RECONHECEM QUE TODA E QUALQUER OBRIGAÇÃO INDENIZATÓRIA DA CONTRATADA À CONTRATANTE SERÁ LIMITADA AO VALOR 
          TOTAL PAGO PELA CONTRATANTE À CONTRATADA NO ÂMBITO DO PLANO CONTRATADO PELO CONTRATANTE.
        </p>
        <p>
          28.4.1. Não será devido à Contratante o pagamento de pela Contratada que seja superior ao valor que foi efetivamente recebido 
          pela Contratada em razão da contratação do plano pela Contratante. 
        </p>
      </section>

      <section class="capitulo">
        <h2>
          29. ALTERAÇÕES E ATUALIZAÇÕES DOS TERMOS E CONDIÇÕES DE USO
        </h2>
        <p>
          29.1. À Contratada será reservado o direito de alterar e/ou atualizar, a qualquer tempo e sem anuência prévia da Contratante, 
          as cláusulas e condições previstas nestes Termos e Condições de Uso.
        </p>
        <p>
          29.2. Na hipótese de alteração e/ou atualização sem anuência da Contratante, esta  será informada conforme o procedimento previsto na 
          Cláusula 21.4 sobre as alterações e/ou atualização dos Termo e Condições de Uso.
        </p>
        <p>
          29.2.1. Caso a Contratante continue utilizando a Plataforma após o aviso das alterações, entender-se-á que houve a aceitação dos 
          novos Termos e Condições de Uso, vinculando-se a Contratante aos direitos e obrigações neles previstos.
        </p>
        <p>
          29.2.2. Não havendo concordância das alterações, a Contratante deverá interromper o uso da Plataforma imediatamente. 
        </p>
      </section>

      <section class="capitulo">
        <h2>30. DISPOSIÇÕES GERAIS FINAIS</h2>
        
        <p>
          30.1. Estes Termo e Condições de Uso representam os contratos definitivos entre a Contratante e a Contratada em relação ao uso da Plataforma, 
          substituindo quaisquer outros contratos ou acordos prévios celebrados entre as Partes, sejam verbais ou escritos.
        </p>

        <p>
          30.2. Estes Termos e Condições de Uso vincularão as Partes e seus respectivos sucessores e representantes, em caráter revogável e irretratável.
        </p>

        <p>
          30.3. É defeso à Contratante, sem a prévia concordância expressa e por escrito da Contratada, transferir ou ceder, no todo ou em 
          parte e a qualquer título, quaisquer direitos e/ou obrigações decorrentes do Plano contratado, sendo certo que a Contratada poderá 
          exigir a apresentação de todo e qualquer tipo de informação acerca do cessionário do Plano, para fins de aprovação ou não de 
          eventual cessão ou transferência.
        </p>

        <p>
          30.4. Todas as comunicações previstas nestes Termos e Condições de Uso serão consideradas válidas e eficazes se respeitarem a 
          forma escrita e forem enviadas por meio de carta ou e-mail às Partes.
        </p>

        <p>
          30.4.1. Eventuais mudanças de dados cadastrais, sobretudo as de endereço e de contato do Contratante deverão ser prontamente 
          comunicadas por escrito à Contratada, sob pena de considerar-se válida e eficaz a entrega de qualquer comunicação prevista 
          nestes Termos e Condições de Uso no endereço não atualizado pelo Contratante.
        </p>

        <p>
          30.5. A tolerância de uma Parte em relação à outra, quanto à violação ou descumprimento de quaisquer das obrigações aqui 
          assumidas, não será considerada moratória, novação ou renúncia a qualquer direito que em seu favor tenha sido aqui 
          estabelecido, constituindo mera liberalidade isolada, que não impedirá a parte tolerante de exigir da outra o fiel 
          cumprimento destes Termos e Condições de Uso, a qualquer tempo.
        </p>

        <p>
          30.6. Caso alguma disposição ou cláusula específica venha a ser declarada nula, abusiva, inválida ou ilegal por uma 
          autoridade judicial ou arbitral, as demais cláusulas e condições permanecerão válidas, vigentes e exequíveis.
        </p>

      </section>
      <section class="capitulo">
        <h2>31. LEI APLICÁVEL E FORO</h2>
        <p>
          31.1. Estes Termos e Condições de Uso serão regidos, interpretados e se sujeitarão exclusivamente às leis da República Federativa do Brasil. 
          As Partes elegem, de forma irrevogável e irretratável, o Foro Central da Comarca de Vitoria/ES para dirimir quaisquer dúvidas ou 
          controvérsias oriundas destes Termos e Condições de Uso, com exclusão de qualquer outro foro, por mais privilegiado que seja.
        </p>
      </section>

      <section class="capitulo">
        <h2>32. DEFINIÇÕES</h2>
        <p>
          32.1. Para fins de interpretação destes Termos e Condições de Uso, as seguintes palavras, expressões e abreviações, 
          com letras iniciais em maiúsculo, terão o significado definido nesta Cláusula 23.1, nada obstante àquelas definidas ao 
          longo destes Termos e Condições de Uso, exceto se indicado expressamente de forma diversa ou quando o contexto for 
          incompatível com qualquer significado aqui indicado:
        </p>

        <p>
          32.1.1. “API” significa Interface de Programação de Aplicativos (Application Programming Interface), entendida como um conjunto de 
          rotinas e padrões de programação para acesso e utilização de informação de um aplicativo de software ou plataforma;

        </p>
        
        <p>
          32.1.2. “Cardápio Digital” significa o cardápio digital que será cadastrado pelo Estabelecimento na Plataforma e 
          estará disponível para acesso e consumo, via Plataforma, pelos Consumidores, no qual constarão informações sobre os dias e 
          horários de atendimento do Estabelecimento, tipos de produtos vendidos, nome do produto, descrição do produto, tamanhos, 
          volumes, quantidades mínimas, valores, taxas de entrega, dentre outras;
        </p>
        <p>
          32.1.3. “Consumidores” significam as pessoas que interagem com o Estabelecimento e adquirem os produtos por ele ofertados por meio da Plataforma;
        </p>
        <p>
          32.1.4. “Controlador de Dados” tem o seu significado atribuído pelo inciso VI do art. 5º da Lei nº 13.709/2018, de 14 de agosto de 2018, 
          conforme alterada de tempos em tempos;
        </p>
        <p>
          32.1.5. “Processo de Ativação” significa o processo de cadastramento das informações do Contratante na Plataforma;
        </p>
        <p>
          32.1.6. “Formulário Inicial” significa o formulário de cadastro disponível para preenchimento na página inicial do site da Contratada;
        </p>
        <p>
          32.1.7. “Lei Geral de Proteção de Dados” significa a Lei nº 13.709, de 14 de agosto de 2018, conforme alterada de tempos em tempos;
        </p>

        <p>
          32.1.8. “Operador de Dados” tem o seu significado atribuído pelo inciso VII do art. 5º da Lei nº 13.709/2018, de 14 de agosto de 2018, 
          conforme alterada de tempos em tempos; 
        </p>

        <p>
          32.1.9. “Parceiros e Afiliados” significam os integrantes dos programas com parceiros e afiliados mantidos pela OverX, 
          os quais estão sujeitos à regulamentação contratual específica;
        </p>

        <p>
          32.1.10. “Plataforma OverX” ou “Plataforma” significam tanto a solução virtual de gestão de atendimento e intermediação de pedidos, 
          de propriedade única e exclusiva da Contratada (“Atendente Virtual”), como a plataforma de criação de cardápios digitais e de oferta 
          e venda de produtos, também de propriedade única e exclusiva da Contratada, bem como de outras soluções que venham a ser 
          desenvolvidas pela Contratada;
        </p>

        <p>
          32.1.11. “Planos” significam as modalidades de assinatura ofertadas no site da Contratada, cada qual com seus benefícios específicos 
          e disponíveis para contratação em periodicidades mensal, semestral ou anual;
        </p>

        <p>
          32.1.12. “Política de Privacidade” significa a política de privacidade disponibilizada no website da OverX;
        </p>

        <p>
          32.1.13. “Software como Serviço” significa um modelo de contratação por assinatura de software remoto, situado em nuvem, 
          para o uso do contratante pela internet. 

        </p>
      </section>
    </div>    
  </div>
</template>

<script>
export default {
  name: 'TermosCondicoes',
  props: {
    mostrarAceitacao: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      aceitouTermos: false
    }
  },
  methods: {
    confirmarAceitacao() {
      this.$emit('aceitou-termos', true)
    }
  }
}
</script>

<style scoped>
.termos-container {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  color: #333;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.termos-header {
  text-align: center;
  border-bottom: 2px solid #2c3e50;
  padding-bottom: 20px;
  margin-bottom: 30px;
}

.termos-header h1 {
  color: #2c3e50;
  margin-bottom: 20px;
  font-size: 2.2rem;
}

.empresa-info {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin: 25px 0;
  border-left: 4px solid orange;
}

.last-update {
  color: #7f8c8d;
  font-size: 1rem;
  margin-top: 15px;
}

.introducao {
  background: #f0f7ff;
  padding: 25px;
  border-radius: 8px;
  margin-bottom: 40px;
  border-left: 4px solid orange;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.introducao p {
  margin-bottom: 15px;
}

.introducao strong {
  color: #2c3e50;
}

.capitulos {
  margin-top: 30px;
}

.capitulo {
  margin-bottom: 50px;
  padding-bottom: 30px;
  border-bottom: 2px solid orange;
}

.capitulo:last-child {
  border-bottom: none;
}

.capitulo h2 {
  color: #2c3e50;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 2px solid orange;
  font-size: 1.8rem;
}

.capitulo h3 {
  color: #34495e;
  margin: 30px 0 20px 0;
  font-size: 1.4rem;
  padding-left: 10px;
  border-left: 3px solid orange;
}

.capitulo h4 {
  color: #2c3e50;
  margin: 25px 0 15px 0;
  font-size: 1.2rem;
}

.capitulo p {
  margin-bottom: 15px;
  text-align: justify;
}

.capitulo ul {
  list-style: none;
  padding-left: 0;
}

.capitulo li {
  margin-bottom: 10px;
  padding-left: 10px;
  position: relative;
}

.capitulo li::before {
  content: none;
}

.planos-table {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 25px;
  margin: 25px 0;
}

.plano-item {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 25px;
  box-shadow: 0 3px 10px rgba(0,0,0,0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.plano-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.plano-item h4 {
  color: #2c3e50;
  margin-top: 0;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.plano-item p {
  margin-bottom: 10px;
  color: #555;
}

.plano-item strong {
  color: black;
}

.funcionalidades {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
  margin: 25px 0;
}

.funcionalidades ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.funcionalidades li {
    list-style-type: none;
    padding: 12px 15px;
    margin-bottom: 8px;
    background: #f8f9fa;
    border-radius: 6px;
    border-left: 3px solid orange;
    transition: background 0.3s ease;
}

.funcionalidades li:hover {
  background: #e8f4fc;
}

.definicoes {
  margin-top: 25px;
}

.definicao-item {
  margin-bottom: 25px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #2ecc71;
}

.definicao-item h4 {
  color: #2c3e50;
  margin-top: 0;
  margin-bottom: 10px;
}

.definicao-item p {
  margin-bottom: 0;
  color: #555;
}

.aceitacao {
  position: sticky;
  bottom: 0;
  background: white;
  padding: 25px;
  border-top: 2px solid #2c3e50;
  box-shadow: 0 -3px 15px rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 50px;
  z-index: 100;
}

.aceitacao label {
  display: flex;
  align-items: center;
  gap: 15px;
  cursor: pointer;
  font-weight: 600;
  color: #2c3e50;
  flex: 1;
  min-width: 300px;
}

.aceitacao input[type="checkbox"] {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.aceitacao button {
  background: linear-gradient(135deg, #27ae60, #219653);
  color: white;
  border: none;
  padding: 15px 40px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.3s ease;
  min-width: 200px;
  box-shadow: 0 4px 6px rgba(39, 174, 96, 0.2);
}

.aceitacao button:disabled {
  background: #bdc3c7;
  cursor: not-allowed;
  box-shadow: none;
}

.aceitacao button:not(:disabled):hover {
  background: linear-gradient(135deg, #219653, #1e8449);
  transform: translateY(-2px);
  box-shadow: 0 6px 8px rgba(39, 174, 96, 0.3);
}

.aceitacao button:not(:disabled):active {
  transform: translateY(0);
}

/* Responsividade */
@media (max-width: 992px) {
  .planos-table {
    grid-template-columns: 1fr;
  }
  
  .funcionalidades {
    grid-template-columns: 1fr;
    gap: 25px;
  }
  
  .termos-header h1 {
    font-size: 1.8rem;
  }
}

@media (max-width: 768px) {
  .termos-container {
    padding: 15px;
  }
  
  .aceitacao {
    flex-direction: column;
    text-align: center;
    padding: 20px;
  }
  
  .aceitacao label {
    min-width: auto;
    text-align: left;
  }
  
  .aceitacao button {
    width: 100%;
    min-width: auto;
  }
  
  .capitulo h2 {
    font-size: 1.5rem;
  }
  
  .capitulo h3 {
    font-size: 1.2rem;
  }
}

@media (max-width: 480px) {
  .termos-header h1 {
    font-size: 1.5rem;
  }
  
  .empresa-info {
    padding: 15px;
  }
  
  .introducao {
    padding: 20px;
  }
  
  .plano-item {
    padding: 20px;
  }
  
  .capitulo {
    padding-bottom: 25px;
    margin-bottom: 35px;
  }
}

@media print {
  .aceitacao {
    display: none;
  }
  
  .termos-container {
    max-width: none;
    padding: 0;
  }
  
  .plano-item {
    break-inside: avoid;
    box-shadow: none;
    border: 1px solid #ccc;
  }
  
  .funcionalidades li {
    break-inside: avoid;
  }
}
</style>